Storage.prototype.setJson = function (key: string, val: any) {
    this.setItem(key, JSON.stringify(val));
};

Storage.prototype.getJson = function (key: string) {
    return JSON.parse(this.getItem(key) as string);
};

export {};
